var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-skeleton',{attrs:{"height":"30px","width":"20%"}}),_c('br'),_c('b-skeleton',{attrs:{"height":"120px"}}),_c('b-skeleton',{attrs:{"height":"30px","width":"30%"}}),_c('hr'),_c('b-skeleton',{attrs:{"height":"120px"}}),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }